export function adminApiHeaders(extra?: HeadersInit): HeadersInit {
  const key = (import.meta.env.VITE_ADMIN_API_KEY as string | undefined)?.trim();
  const base: Record<string, string> = {};
  if (key) base['X-Admin-Key'] = key;

  if (!extra) return base;
  if (Array.isArray(extra)) {
    return [...Object.entries(base), ...extra];
  }
  if (extra instanceof Headers) {
    const headers = new Headers(extra);
    Object.entries(base).forEach(([k, v]) => headers.set(k, v));
    return headers;
  }
  return { ...base, ...extra };
}
